/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import JsonQuery from 'json-query';
import { hooks as commonHooks, types as commonTypes } from '@sitebuilder/common';
import {
    getTextSchemaProperties,
    getStyleSchemaProperties,
    getLayoutSchemaProperties,
} from '../utils';
import disclaimerStyles from './Disclaimer.styles';

interface AnnotationData {
    annotationId: string;
    id: string;
    text: string;
    textHtml: string | null;
    textTargetId: string;
    markerTargetId: string | null;
    markerType: string | null;
    marker: string | null;
}

interface WidgetProperties extends commonTypes.WidgetPropertiesBase {
    annotationDatakey: string;
    _data?: Object;
    typographyClass?: string;
}

interface WidgetProps extends commonTypes.WidgetInstanceProps {
    _data?: object;
}

const Disclaimer = (props: WidgetProps) => {
    const { widgetInstanceId } = props;
    const widgetProperties = commonHooks.useWidgetProperties<WidgetProperties>(widgetInstanceId);
    const { styles, annotationDatakey } = widgetProperties || props;

    const { data, _data } = props;
    const mockedData = [
        {
            annotationId: '7aac70c5-0dae-40c8-8420-df35ff8de8c9',
            id: '7aac70c5-0dae-40c8-8420-df35ff8de8c9',
            text: 'testing disclaimer',
            textHtml: null,
            textTargetId: 'disclaimers',
            markerTargetId: null,
            markerType: null,
            marker: null,
        },
        {
            annotationId: '7a6dddcd-3819-4848-9915-6e5e019051b9',
            id: '7a6dddcd-3819-4848-9915-6e5e019051b9',
            text: `All investments have risk. 
          Past performance is not indicative of future performance.`,
            textHtml: null,
            textTargetId: 'disclaimers',
            markerTargetId: null,
            markerType: null,
            marker: '†',
        },
        {
            annotationId: 'd20a2a30-e8a0-462e-bc2c-a235f18d8fec',
            id: 'd20a2a30-e8a0-462e-bc2c-a235f18d8fec',
            text: 'All Series Combined',
            textHtml: null,
            textTargetId: 'disclaimers',
            markerTargetId: 'aumValue',
            markerType: null,
            marker: '†††',
        },
    ];
    const annotations: AnnotationData[] =
        mockedData || JsonQuery(annotationDatakey as string, { data }) || _data;

    return (
        <div>
            {annotations.map((a: any) => (
                <div
                    key={a.text}
                    className={
                        widgetProperties?.typographyClass ? widgetProperties.typographyClass : ''
                    }
                    css={css`
                        ${disclaimerStyles}${getTextSchemaProperties(
                            widgetProperties,
                            data?.colorSpace
                        )}${getStyleSchemaProperties(widgetProperties)}${getLayoutSchemaProperties(
                            widgetProperties
                        )}${styles || ''}
                    `}
                >
                    <p>
                        <span>{a.marker && <sup>{a.marker}</sup>}</span>
                        <span>{a.text}</span>
                    </p>
                </div>
            ))}
        </div>
    );
};

export default Disclaimer;
